module.exports = __webpack_public_path__ + "img/dr-Giovanni-Moreno.d5ca71b0.jpg";